
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 24","fill":"#B39F5E","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.235 9.978V7.42l1.387 1.034 1.131-1.557L10.503 0 1.246 6.897l1.131 1.557L3.764 7.42v2.56L0 12.874v.48C0 19.225 4.71 24 10.5 24S21 19.225 21 13.355v-.48l-3.765-2.897zM5.672 5.998L10.5 2.4l4.826 3.597V8.51l-4.826-3.714L5.671 8.51V5.997zM10.5 7.225l8.58 6.603a8.719 8.719 0 01-.336 1.956l-8.245-6.146-8.241 6.14a8.773 8.773 0 01-.335-1.95l8.577-6.603zm-7.483 10.39l6.53-4.868v9.259a8.529 8.529 0 01-3.787-1.398 8.675 8.675 0 01-2.743-2.994zm8.439 4.39v-9.254l6.528 4.866a8.671 8.671 0 01-2.742 2.992 8.524 8.524 0 01-3.786 1.397z"}})])
          )
        }
      }
    